import React from 'react';
import { injectIntl } from 'react-intl';

const FieldValidationResultMessage = (props) => {
	const status = props?.status ?? false;

	let message = '';
	let classes = [];
	if(status) {
		classes.push('gui_validation_field_ok');
		message = 'OK';
	} else {
		classes.push('gui_validation_field_ko');
		message = 'KO';
	}

	if(props.error_msg_position_class != undefined) {
		classes.push(props.error_msg_position_class);
	}

	return (
		<div class={classes.join(" ")}>{props.intl.formatMessage({id:message})}</div>
	)
}

export default injectIntl(FieldValidationResultMessage);